module.exports = __webpack_public_path__ + "media/assets/images/header-mobile-c9d42ac207ec55d61d7f693b975c9ec3.svg";